import {Stack} from "@mui/material";
import type {HashResolver} from "../../../../../../sdo/Resolver.ts";
import {MatchModeRow, F, Sel, SummaryPill, SummaryPillRow, rowSx, set, type ResolverEditorProps} from "./ResolverUtils.tsx";

function HashEditor({draft, editing, onChange}: ResolverEditorProps & { draft: HashResolver }) {
    if (!editing) {
        return (
            <SummaryPillRow>
                <SummaryPill label="Hash Type" value={draft.hashType}/>
                <SummaryPill label="Hash Value" value={draft.hashValue}/>
            </SummaryPillRow>
        );
    }

    const upd = (key: string, value: unknown) => set(draft, key, value, onChange);
    return (
        <Stack direction="column" spacing={1} alignItems="center">
            <MatchModeRow draft={draft} editing={editing} onChange={onChange}/>
            <Stack direction="row" sx={rowSx}>
                <Sel value={draft.hashType} label="Hash Type" onChange={(v) => upd("hashType", v)} options={[
                    {value: "MD5", label: "MD5"},
                    {value: "SHA1", label: "SHA1"},
                    {value: "SHA256", label: "SHA256"},
                    {value: "SHA512", label: "SHA512"},
                ]}/>
                <F value={draft.hashValue} placeholder="Hash Value" onChange={(v) => upd("hashValue", v)} width="300px"/>
            </Stack>
        </Stack>
    );
}

export default HashEditor;
